import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Chip from '@material-ui/core/Chip';
import Box from '@material-ui/core/Box';

const MAX_VISIBLE = 2;

const useStyles = makeStyles(({ palette, spacing }) => ({
  tagChip: {
    height: 16,
    fontSize: '9px',
    fontWeight: 600,
    textTransform: 'uppercase',
    color: palette.text.secondary,
    borderColor: palette.divider,
    marginRight: spacing(1),
    marginBottom: spacing(1),
  },
  tagChipRunning: {
    height: 16,
    fontSize: '9px',
    fontWeight: 600,
    textTransform: 'uppercase',
    color: palette.common.white,
    borderColor: palette.common.white,
    marginRight: spacing(1),
    marginBottom: spacing(1),
  },
  moreChip: {
    height: 16,
    fontSize: '9px',
    fontWeight: 600,
    color: palette.text.secondary,
    borderColor: palette.divider,
    marginRight: spacing(1),
    marginBottom: spacing(1),
  },
  moreChipRunning: {
    height: 16,
    fontSize: '9px',
    fontWeight: 600,
    color: palette.common.white,
    borderColor: palette.common.white,
    marginRight: spacing(1),
    marginBottom: spacing(1),
  },
}));

const ProjectTags = ({ tags, isReady }) => {
  const classes = useStyles();
  const names = tags
    .map((tag) => {
      if (typeof tag === 'string') return tag;
      if (typeof tag === 'number') return null;
      return tag.displayName;
    })
    .filter(Boolean);

  const visible = names.slice(0, MAX_VISIBLE);
  const remaining = names.length - MAX_VISIBLE;

  if (!visible.length) return null;

  const chipClass = isReady ? classes.tagChip : classes.tagChipRunning;
  const moreClass = isReady ? classes.moreChip : classes.moreChipRunning;

  return (
    <Box display="flex" flexWrap="wrap">
      {visible.map((name) => (
        <Chip
          key={name}
          label={name}
          size="small"
          variant="outlined"
          className={chipClass}
        />
      ))}
      {remaining > 0 && (
        <Chip
          label={`+${remaining}`}
          size="small"
          variant="outlined"
          className={moreClass}
        />
      )}
    </Box>
  );
};

ProjectTags.propTypes = {
  tags: PropTypes.array.isRequired,
  isReady: PropTypes.bool,
};

ProjectTags.defaultProps = {
  isReady: true,
};

export default ProjectTags;
